import React from 'react'
import PropTypes from 'prop-types'

const ActionItem = props => {
  return (
    <span className={`list-item ${props.alt === 'account' ? 'second-level account-login yettel-light-font' : ''} ${props.active ? 'active' : ''}`} onClick={props.handleClick}>
        <>{props.title}<img  width="32" alt={props.alt} className="icon " src={props.src}/></>
    </span>
  )
}

ActionItem.propTypes = {
  src: PropTypes.string.isRequired,
  alt: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
}

export default ActionItem
